import { clear, createStore, del, get, set } from 'idb-keyval';

class Storage {
  constructor(app) {
    this.app = app;
    this.store = createStore('straightline', 'storage');
  }

  async get(key) {
    return get(key, this.store);
  }

  async set(key, value) {
    return set(key, value, this.store);
  }

  async del(key) {
    return del(key, this.store);
  }

  async clear() {
    return clear(this.store);
  }
}

export default function (app) {
  app.storage = new Storage(app);

  app.cleanup = async function (redirect) {
    app.auth = null;
    localStorage.clear();
    app.storage.clear();
    if (redirect) {
      window.location.href = `/login?redirect=${redirect}`;
    } else {
      window.location.href = '/login';
    }
  };

  const versionKey = 'straightline-version';
  const newVersion = process.env.REACT_APP_BUILD_ID;
  const currentVersion = localStorage.getItem(versionKey);
  localStorage.setItem(versionKey, newVersion);

  if (currentVersion && currentVersion !== newVersion) {
    app.cleanup();
  }
}
